import { hero } from '../content/site';

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-sunset-gradient pt-16 text-cream"
      aria-label="Introduction"
    >
      {/* Soft glow to echo the sun in the logo mark */}
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-24 h-72 w-72 -translate-x-1/2 rounded-full bg-gold/40 blur-3xl sm:h-96 sm:w-96"
      />

      <div className="container-page relative flex min-h-[85vh] flex-col items-center justify-center py-24 text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-gold-light">
          {hero.eyebrow}
        </p>

        <h1 className="mt-4 max-w-3xl text-4xl leading-tight sm:text-5xl md:text-6xl">
          {hero.headline}
        </h1>

        <p className="mt-6 max-w-xl text-base text-cream/85 sm:text-lg">{hero.subheadline}</p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href={hero.primaryCta.href}
            className="rounded-full bg-cream px-6 py-3 text-sm font-semibold text-dusk shadow-soft transition-transform hover:scale-[1.03]"
          >
            {hero.primaryCta.label}
          </a>
          <a
            href={hero.secondaryCta.href}
            className="rounded-full border border-cream/40 px-6 py-3 text-sm font-semibold text-cream transition-colors hover:bg-cream/10"
          >
            {hero.secondaryCta.label}
          </a>
        </div>
      </div>

      {/* Horizon line, echoing the logo's water horizon */}
      <div aria-hidden className="h-2 w-full bg-gradient-to-r from-transparent via-cream/60 to-transparent" />
    </section>
  );
}
